import { useFormik } from "formik";
import { Alert, Form } from "antd";
import AppInput from "../../../../components/ui/AppInput";
import AppButton from "../../../../components/ui/AppButton";
import { emailStepInitialValues, emailStepSchema } from "../ForgotPasswordForm.schema";

/**
 * EmailStep — step 1 of the forgot-password wizard.
 *
 * Submits the email to {@code /auth/forgot-password/start}. Anti-enumeration:
 * the BE always returns 200, so any non-empty submit advances the wizard.
 */
export default function EmailStep({ initialEmail = "", submitting, errorMessage, onSubmit }) {
  const formik = useFormik({
    initialValues: { ...emailStepInitialValues, email: initialEmail },
    validationSchema: emailStepSchema,
    enableReinitialize: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async (values) => {
      await onSubmit(values.email.trim().toLowerCase());
    },
  });

  return (
    <Form
      layout="vertical"
      onFinish={formik.handleSubmit}
      requiredMark={false}
      className="mt-8 space-y-4"
    >
      <p className="text-sm text-mahogany">
        Enter the email you use to sign in. We&apos;ll send a 6-digit code to reset your password.
      </p>
      <AppInput
        id="forgot-email"
        name="email"
        type="email"
        label="Email"
        required
        size="large"
        autoComplete="email"
        placeholder="you@sulsa.in"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        status={formik.touched.email && formik.errors.email ? "error" : undefined}
        error={formik.touched.email ? formik.errors.email : undefined}
      />

      {errorMessage && <Alert type="error" showIcon message={errorMessage} role="alert" />}

      <AppButton
        htmlType="submit"
        type="primary"
        size="large"
        block
        loading={submitting}
        disabled={submitting}
        label="Send code"
      />
    </Form>
  );
}
